import React from "react";
import CustomHeader from "../headers/CustomHeader";
import CustomFooter from "../CustomFooter";
import BannerMain from "../BannerMain";
import { Button, Form, Input, Radio } from "antd";

const { TextArea } = Input;

const AedDetails = () => {
  return (
    <>
      <BannerMain headingName={"Aed detail"} />
      <div className="main-inner-fluid">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-9 mx-auto">
              <Form
                className="common-form-main"
                name="basic"
                labelCol={{
                  span: 24,
                }}
                wrapperCol={{
                  span: 24,
                }}
                // initialValues={{
                //     remember: true,
                // }}
                // onFinish={onFinish}
                // onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <div className="row gallery-img-row-card">
                  <div className="col-12 col-sm-12 col-md-6">
                    <Form.Item
                      label="Aed device available:"
                      name="aed_device_available"
                      rules={[
                        {
                          required: false,
                          message:
                            "Please Select Your Aed device Availability!",
                        },
                      ]}
                    >
                      <Radio.Group name="radiogroup" defaultValue={1}>
                        <Radio value={1}>Yes</Radio>
                        <Radio value={2}>No</Radio>
                      </Radio.Group>
                    </Form.Item>
                    <Form.Item
                      label={false}
                      name="model_of_the_device"
                      rules={[
                        {
                          required: false,
                          message: "Please Input Model of the Device!",
                        },
                      ]}
                    >
                      <Input placeholder="Model of the Device" />
                    </Form.Item>
                    <Form.Item
                      label={false}
                      name="serial_no"
                      rules={[
                        {
                          required: false,
                          message: "Please Input Serial No. of Device!",
                        },
                      ]}
                    >
                      <Input placeholder="Serial No. of Device" />
                    </Form.Item>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6">
                    <Form.Item
                      label={false}
                      name="type_of_device"
                      rules={[
                        {
                          required: false,
                          message: "Please Input Your Type of Device (Make)!",
                        },
                      ]}
                    >
                      <Input placeholder="Type of Device (Make)" />
                    </Form.Item>
                    <Form.Item
                      label={false}
                      name="additional_info"
                      rules={[
                        {
                          required: false,
                          message: "Please Input Additional Info : Freetext!",
                        },
                      ]}
                    >
                      <TextArea
                        className="textArea-custom"
                        placeholder="Additional Info : Freetext"
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 text-center">
                    <Button className="go-back-dashboard-btn">Submit</Button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AedDetails;
